import { render, staticRenderFns } from "./BatchesPanel.vue?vue&type=template&id=61ac5baa&scoped=true"
import script from "./BatchesPanel.vue?vue&type=script&lang=js"
export * from "./BatchesPanel.vue?vue&type=script&lang=js"
import style0 from "./BatchesPanel.vue?vue&type=style&index=0&id=61ac5baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac5baa",
  null
  
)

export default component.exports